export enum OffCatalogStep {
  "AskTrainingDesired" = 0,
  "WhichTraining" = 11,
  "UserSpecifyContext" = 12,
  "ManagerSpecifyContext" = 21,
}
